export enum RefundProgressStatus {
  Completed = 'completed',
  Pending = 'pending',
  Failed = 'failed',
}
